<template>
    <div class="form-type-0">
        <form @submit.prevent="cloneAudience" @input="onInputChange" ref="form" novalidate>
            <CustomInput
                v-model="name"
                inputKey="audience_name"
                ref="name"
                pattern="^[a-zA-Z0-9 _-]+$"
                required
            />
            <button type="submit" :disabled="loading">
                <span v-if="loading" class="loading-spinner-type-1"></span>
                <span v-else>{{ $t('forms.clone_audience.button') }}</span>
            </button>
            <p v-if="formError" class="form-error">{{ $t('forms.clone_audience.error') }}</p>
        </form>
    </div>
</template>

<script>
    import { useAudienceStore } from '@/stores/audience';
    import formMixin from '@/mixins/formMixin';
    import CustomInput from '@/components/inputs/CustomInput';

    export default {
        mixins: [formMixin],
        emits: ['form_submission_successful'],
        components: {
            CustomInput
        },
        props: {
            audience: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                name: ''
            };
        },
        computed: {
            audienceStore() {
                return useAudienceStore();
            }
        },
        methods: {
            async cloneAudience() {
                const form = this.$refs.form;
                if(form.checkValidity()) {
                    this.loading = true;
                    let newAudience = {
                        name: this.name,
                        company_options: this.audience.company_options,
                        qid: this.audience.qid
                    };
                    const success = await this.audienceStore.createAudience(newAudience);
                    this.loading = false;
                    
                    if (success) {
                        form.reset();
                        this.formError = false;
                        this.$emit('form_submission_successful');
                    } else {
                        this.formError = true;
                    }
                } else {
                    this.validateAllFields();
                }
            }
        }
    }
</script>